<template>
  <div id="next-steps" class="header-padding bg-light-grey">
    <header class="page-header ff ff-center horizontal-padding section-padding" style="padding-bottom: 0;">
      <h1>Next Steps</h1>
      <p>What would you like to do with your estimates?</p>
      <hr class="hr-100 hr-cyan">
    </header>
    
    <section role="content" id="next-steps-content" class="horizontal-padding section-padding max-width">
      <div class="content-block ff ff-ttb ff-center">
        <h2 class="cyan">Estimates</h2>
        
        <div class="ff-12">
          <div class="ff-columns">
            <article class="ff-12">
              <div class="bg-white tile">
                <div class="padding min-padding ff ff-nowrap ff-ttb ff-center ff-lg-ltr ff-lg-text-left">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" v-bind:svg-inline="''" v-bind:title="'Estimates'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M43.8 30.5H17.5M43.8 37.3H17.5M34.8 44.1H17.5M45.7 57.7H17.5M39.3 50.9H17.5M45.7 7.4v10.3c0 1.7 1.3 3 3 3H59"/><path opacity=".4" fill="#00A0C8" d="M10.2 66.3c-3.6.7-5.6 1.5-5.6 2.3 0 2.2 13.5 4 30.1 4s30.1-1.8 30.1-4c0-.9-2.2-1.7-5.9-2.3v.1c0 1.9-1.6 3.5-3.5 3.5H13.7c-1.9 0-3.5-1.6-3.5-3.6z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M59 30.2v-9.5L45.7 7.4H13.6c-1.9 0-3.5 1.6-3.5 3.5v55.5c0 1.9 1.6 3.5 3.5 3.5h41.9c1.9 0 3.5-1.6 3.5-3.5v-4.6"/><g fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M61.1 39.9c-.5-.7-1.3-1.2-2.2-1.2-1.4 0-2.6 1.2-2.6 2.6 0 1.4 1.2 2.6 2.6 2.6"/><path d="M56.2 48c.4 1.1 1.5 1.8 2.7 1.8 1.6 0 3-1.3 3-3s-1.3-3-3-3M58.9 37.9v-1.4M58.9 51.7v-1.5"/></g><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M49.8 30.2V44h-5.5c-1.3 0-1.9 1.5-1 2.4L57 60.2c1.1 1.1 3 1.1 4.2 0l13.7-13.7c.9-.9.3-2.4-1-2.4h-5.5V30.2H54"/><path opacity=".4" fill="#00A0C8" d="M73.8 44.1h-5.5V30.5H65v13.3c0 1.7.7 3.2 2.5 3.6.5.1.6.7.3 1.1L56.3 60h-.1l.6.6h3.9l13.1-13.1c2.4-2.4 1.6-3.4 0-3.4z"/><path opacity=".4" fill="#00A0C8" d="M42.8 47.2L59 62.3v5.2zM48.6 11.1h.6l8.7 8.7v.8h-6.6c-1.5 0-2.8-1.3-2.8-2.8s.1-6.7.1-6.7z"/></svg>
                  <hr class="hr-50 hr-rotate" />
                  <p class="ff-lg-fill lg-padding-right">Download a pdf of your price estimates for your records. </p>
                  <router-link to="/estimates/download/estimates" class="btn bg-cyan ff-lg-auto" @click.native="trackClick('download','estimates')">
                    <icon name="icon-download" color="white" size=18 />
                    <span>Download</span>
                  </router-link>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      
      <div class="separator-or">
        <h5 class="grey bg-light-grey">Or</h5>
      </div>
      
      <div class="content-block ff ff-ttb ff-center">
        <h2 class="cyan">Send your samples to the lab</h2>
        <p>If you’re ready to send your samples to the lab, these are your options:</p>
        
        <div class="ff-12">
          <div class="ff-columns">
            <article class="ff ff-12 ff-lg-4">
              <div class="bg-white tile">
                <div class="padding min-padding">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" v-bind:svg-inline="''" v-bind:title="'Request Forms'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" fill="#00A0C8" d="M15.7 25.2v21.5h39.9c1.5 0 2.7-1.2 2.7-2.7V27.8c0-1.5-1.2-2.7-2.7-2.7H15.7zM40 42.3H20.8V38H40v4.3zm0-8.5H20.8v-4.4H40v4.4zm13.9 8.5H44V38h9.8v4.3zm0-8.5H44v-4.4h9.8v4.4z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M37 14.8H20.8M39.8 20.7h-19M33.2 53.7h-4M57.6 53.7H37M44 61.9H29.2M57.6 61.9h-9.9M20.8 29.5H40v4.4H20.8zM44 29.5h9.8v4.4H44zM20.8 38H40v4.4H20.8zM44 38h9.8v4.4H44z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M50.9 7.4H18.8c-1.9 0-3.5 1.6-3.5 3.5v55.5c0 1.9 1.6 3.5 3.5 3.5h41.9c1.9 0 3.5-1.6 3.5-3.5V20.7L50.9 7.4z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M50.9 7.4v10.3c0 1.7 1.3 3 3 3h10.3"/><circle fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="23" cy="53.7" r="2.2"/><circle fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="23" cy="61.9" r="2.2"/><path opacity=".4" fill="#00A0C8" d="M15.5 66.3c-3.6.7-5.6 1.5-5.6 2.3 0 2.2 13.5 4 30.1 4s30.1-1.8 30.1-4c0-.9-2.2-1.7-5.9-2.3v.1c0 1.9-1.6 3.5-3.5 3.5H19c-2 0-3.5-1.6-3.5-3.6z"/></svg>
                  <h3 class="cyan">Request Forms</h3>
                  <hr class="hr-50" />
                  <p>Download an analysis request form prefilled with the tests you’ve selected so far. You can complete the rest of the form in the editable pdf or by hand.</p>
                  <router-link to="/estimates/download/request-forms" class="btn bg-cyan" @click.native="trackClick('download','prefilled request forms')">
                    <icon name="icon-download" color="white" size=18 />
                    <span>Download</span>
                  </router-link>
                  
                  <div class="separator-or small">
                    <h5 class="bg-white">Or</h5>
                  </div>
                  
                  <p>Download a blank editable analysis request form.</p>
                  <router-link to="/faq/downloads/downloads" class="btn bg-cyan" @click.native="trackClick('download','blank request forms')">
                    <icon name="icon-download" color="white" size=18 />
                    <span>Download</span>
                  </router-link>
                </div>
              </div>
            </article>
            
            <article class="ff ff-12 ff-lg-4">
              <div class="bg-white tile">
                <div class="padding min-padding">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" v-bind:svg-inline="''" v-bind:title="'DIY'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" fill="#00A0C8" d="M59.2 32.3s-.1-.2-.2-.5c-8.4 9.8-19 14.4-36.8 14.4v10.5H51c2.9 0 4.2-2 4.8-3.2 0 0 1.4-3 .3-5.2 0 0 2.8-2.4 1.7-7.8 0 0 3.2-2.3 1.4-8.2zM49.8 11.2c-.2-1.8-.8-2.8-1.5-3.4-1.8.9-1.9 2.8-1.9 2.8C46.4 22 43 24 40.5 26.2h7.3c2.9-5.5 2-15 2-15z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M62.9 53.5c-.6 1.2-1.9 3.2-4.8 3.2H27.4"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M27.4 56.7h30.8c2.9 0 4.2-2 4.8-3.2 0 0 1.4-3 .3-5.2M27.8 28.1c2.9-.9 13.9-5 13.9-17.7 0 0-.1-2.8 3.8-3.2 0 0 3.9-.7 4.3 4 0 0 1 8.5-1.8 14.1h16.7s1.7-.1 2.5 1.9M13.3 27.2h8.9v31.7h-9.7M67.5 30c-.3 1.6-1.5 3.5-4.4 3.5h-1.4M66.6 37.8c-.3 1.6-1.5 3.5-4.4 3.5h-1.4"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M64.7 45.8c-.3 1.6-1.5 3.5-4.4 3.5h-1.4"/><ellipse opacity=".4" fill="#00A0C8" cx="40" cy="69.3" rx="32.3" ry="3.5"/></svg>
                  <h3 class="cyan">DIY</h3>
                  <hr class="hr-50" />
                  <p>If you prefer to use your own paperwork, you can send your request any way you choose. Here’s what we need to know. </p>
                  <router-link to="/faq/sending-samples/what-information-do-i-need-to-provide-with-my-samples" class="btn bg-cyan" @click.native="trackClick('read more','')">
                    <icon name="icon-edit" color="white" size=18 />
                    <span>Read more</span>
                  </router-link>
                </div>
              </div>
            </article>
            
            <article class="ff ff-12 ff-lg-4">
              <div class="bg-white tile">
                <div class="padding min-padding">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" v-bind:svg-inline="''" v-bind:title="'Apps'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" fill="#00A0C8" d="M39.7 31.7c0-6 4.3-11.1 10-12.2v-9.2c0-1.6-1.3-2.8-2.8-2.8h-8c-.9 7-.6 33.8-19.7 40.3v6.4h30.6V43.9c-5.7-1.1-10.1-6.1-10.1-12.2z"/><path opacity=".4" fill="#00A0C8" d="M57.9 20.6c1.5 2 2.4 4.6 2.4 7.3 0 6.9-5.6 12.5-12.5 12.5-2 0-4-.5-5.7-1.4 2.3 3.1 5.9 5.2 10.1 5.2 6.9 0 12.5-5.6 12.5-12.5 0-4.8-2.8-9-6.8-11.1z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M64.7 31.7c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5 5.6-12.5 12.5-12.5c6.9.1 12.5 5.6 12.5 12.5z"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.2 31.5l5 4.1 6.2-8.2"/><path fill="none" stroke="#00A0C8" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M49.7 48.4v18.3c0 1.5-1.3 2.8-2.8 2.8H18.1c-1.5 0-2.8-1.3-2.8-2.8V10.3c0-1.5 1.3-2.8 2.8-2.8h28.7c1.5 0 2.8 1.3 2.8 2.8v4.9M30.2 63.3h4.6M19.3 58h26.4"/><path opacity=".4" fill="#00A0C8" d="M49.7 66.7v.1c0 1.5-1.2 2.7-2.7 2.7H18c-1.2 0-2.2-.8-2.5-1.8-4.4.5-7 1.2-7 1.9 0 1.6 14.1 3 31.6 3s31.6-1.3 31.6-3c-.1-1.4-9.3-2.5-22-2.9z"/></svg>
                  <h3 class="cyan">Sampling apps</h3>
                  <hr class="hr-50" />
                  <p>If you prefer using a sampling app, use DecipherAg Mobile to submit your requests.</p>
                  <router-link to="/faq/sending-samples/do-you-have-a-sampling-app-i-can-use" class="btn bg-cyan" @click.native="trackClick('read more','')">
                    <icon name="icon-edit" color="white" size=18 />
                    <span>Read more</span>
                  </router-link>
                  <div class="decipher-watermark">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 461 34" tabindex="-1" v-bind:svg-inline="''" v-bind:title="'DecipherAg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.92 16.71c0-8.45 5.96-14.96 15.1-14.96 5.96 0 10.67 3.19 12.74 7.34l-1.94 1.11C25.02 6.46 21 3.97 16.15 3.97c-7.62 0-12.74 5.54-12.74 12.74s5.12 12.74 12.88 12.74c4.99 0 9-2.49 10.8-6.23l1.94 1.11c-2.08 4.16-6.79 7.34-12.88 7.34C7.01 31.67.92 25.16.92 16.71zM36.1 27.37l1.25-1.94c2.91 2.77 6.79 4.02 11.5 4.02 6.37 0 10.25-2.49 10.25-6.65 0-3.74-3.88-4.02-10.67-4.99-5.68-.83-11.77-1.52-11.77-7.34 0-5.26 4.71-8.73 11.63-8.73 5.96 0 10.39 2.77 12.05 6.65L58.4 9.51c-1.25-3.32-4.85-5.54-10.11-5.54-5.82 0-9.28 2.63-9.28 6.37s3.88 4.29 9.7 5.12c6.23.83 12.74 1.25 12.74 7.2 0 5.68-5.12 8.86-12.6 8.86-4.86.15-9.43-1.1-12.75-4.15zm34.62-25.2H85.4c4.99 0 8.31 3.32 8.31 7.76 0 3.19-1.66 5.26-4.02 6.37 3.46.69 6.09 3.32 6.09 7.2 0 4.71-3.74 7.62-8.31 7.62H70.72V2.17zM85.68 15.6c3.6 0 5.82-2.08 5.82-5.4 0-3.46-2.35-5.82-5.96-5.82H73.22V15.6h12.46zm1.8 13.44c3.6 0 5.96-2.35 5.96-5.68s-2.49-5.68-5.96-5.68h-14.4v11.36h14.4zm42.25-18.01c0 5.26-4.02 8.86-9.56 8.86h-12.74v11.36h-2.35V2.17h15.09c5.54 0 9.56 3.6 9.56 8.86zm-2.36 0c0-4.02-3.05-6.65-7.34-6.65h-12.6v13.3h12.6c4.3 0 7.34-2.49 7.34-6.65z"/><path d="M177.93 16.71c0 8.31-6.51 14.54-15.1 14.54h-12.19V2.17h12.19c8.59 0 15.1 6.23 15.1 14.54zm-6.65 0c0-4.99-3.46-8.45-8.45-8.45h-5.54v16.76h5.54c4.85.14 8.45-3.32 8.45-8.31zm37.95 8.45v6.09h-23.55V2.17h23.27v6.09h-16.62v5.26h10.53v6.09h-10.53v5.4h16.9v.15zm4.57-8.45c0-8.31 5.82-15.1 15.1-15.1 6.23 0 10.94 3.05 13.02 7.48l-5.54 3.19c-1.11-2.63-3.88-4.43-7.34-4.43-5.4 0-8.45 3.88-8.45 8.86s3.19 8.86 8.59 8.86c3.6 0 6.37-1.8 7.48-4.43l5.54 3.19c-2.08 4.43-6.93 7.48-13.16 7.48-9.28 0-15.24-6.79-15.24-15.1zm41.83-14.54v29.09h-6.65V2.17h6.65zm35.18 9.97c0 5.82-4.43 9.97-10.11 9.97h-9.28v9.14h-6.65V2.17h15.93c5.68 0 10.11 4.15 10.11 9.97zm-6.64 0c0-2.35-1.8-4.02-4.29-4.02h-8.59v8.17h8.59c2.35 0 4.29-1.66 4.29-4.15zm40.44-9.97v29.09h-6.65V19.34h-13.3v11.91h-6.65V2.17h6.65v11.08h13.3V2.17h6.65zm32.69 22.99v6.09h-23.55V2.17h23.27v6.09H340.4v5.26h10.53v6.09H340.4v5.4h16.9v.15zm34.76 5.82v.28H385l-6.65-9.83h-7.2v9.83h-6.65V2.17h15.51c5.82 0 10.11 3.88 10.11 9.7 0 4.02-2.22 7.2-5.54 8.59l7.48 10.52zm-20.77-15.24h8.17c2.49 0 4.29-1.39 4.29-3.88 0-2.35-1.8-3.74-4.29-3.74h-8.17v7.62zm56.37 15.1v.42h-7.2l-2.08-5.12h-13.57l-2.08 5.12h-7.2v-.42L408 2.17h6.93l12.73 28.67zm-11.64-10.39l-4.43-10.94-4.43 10.94h8.86zm43.77-5.54v11.63c-3.05 3.46-7.48 5.26-12.88 5.26-10.25 0-16.21-6.79-16.21-14.96 0-8.31 5.96-15.1 15.51-15.1 6.23 0 10.94 2.91 13.02 7.48l-5.68 2.91c-1.11-2.35-3.46-4.29-7.34-4.29-5.54 0-8.86 3.74-8.86 9 0 5.12 3.19 9 9.56 9 2.49 0 4.71-.55 6.65-2.08V20.3h-6.93v-5.4l13.16.01z" class="2B4464"/></svg>
                  </div>
                </div>
              </div>
            </article>
            
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "NextSteps",
  data() {
    return {
      
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    meta() {
      var meta = {
        title: "Next Steps",
        url: "https://www.csbplab.com.au/estimates/next-steps",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
  },
  mounted() {
    
  },
  methods: {
    trackClick(btn, download) {
      if(download) {
        this.$gtm.trackEvent({
          'event': 'download document',
          'action': 'click',
          'button-name': btn,
          'document-name': download
        });
      } else {
        this.$gtm.trackEvent({
          'event': 'review',
          'action': 'click',
          'button-name': btn
        });
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>